<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Delivery Status Report</strong>        
            <div class="card-header-actions">
              <a  @click="refresh" title="Refresh">  <span class="icon is-medium" >
                <span class="fa fa-refresh" id="refreshId" > </span>
                </span>
              </a>
            </div> 
          </div>
         
            
            <b-form data-vv-scope="form-1">
              <b-row class="mb-4">
                 <b-col md="4">
                   <b-form-group label="Select Rider"  :label-cols="4" >

                    <ejs-multiselect id='multiselect' placeholder="Select Rider" v-model="value2" :dataSource='options'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>

                   <!-- <b-form-select v-model="customer.deliveryagentmasterid" id="deliveryagent_from" name="deliveryagentname" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }" v-on:change="getdeliveragentlistto();  ">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer.deliveryagentmasterid" v-for="customer in data1"  :disabled="customer.capacityforallocation== 0">{{ customer.deliveryagentfirstname | capitalize }} {{ customer.deliveryagentlastname | capitalize }} - {{ customer.deliveryagentmasterid | capitalize }}</option>
                    </b-form-select>  -->

                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </b-col>  
                 <b-col md="4">
                   <b-form-group label="Select Date"  :label-cols="4" >

                   <v-date-picker  mode='single'  :available-dates='{ start: null, end: new Date() }' v-model='selectedDate'>
                      </v-date-picker>

                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </b-col>  
                 







                <!--   <b-col sm="1">                 
                    <label for="Client">Date</label>                  
                  </b-col>    
                  <b-col sm="3">
                   <v-date-picker  mode='single'  :available-dates='{ start: null, end: new Date() }' v-model='selectedDate'>
                      </v-date-picker>
                  </b-col>  -->
                  <b-col sm="3">
                    <b-form-group>
                     <b-button  size="md" variant="primary" v-on:click="displaydata()"> Submit</b-button> &nbsp;
                      
                    </b-form-group>
                  </b-col>
              
             <!--      <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->
                  
              </b-row>          
            </b-form> 
            <b-row class="mb-4">             


              <!-- <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->

              <!-- <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                  <b-input-group>
                    <b-form-select v-model="sortBy" :options="sortOptions">
                      <option slot="first" :value="null">-- none --</option>
                    </b-form-select>
                    <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                      <option :value="false">Asc</option> <option :value="true">Desc</option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>             
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>  -->           
            </b-row> 
            <!-- {{items}} -->
            <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows /2}}</span></b> </p>
              </b-col> 
      
           <!--  <b-table show-empty stacked="md"  stickyHeader :items="items" :fields="fields"  :current-page="currentPage"   :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered" > 
              <template slot="top-row">
             <td class="totalback" ><b>Total</b></td>
            <td class="totalback"><b>{{forwardpickuptotal}}</b></td> 
            <td class="totalback"><b>{{reversepickuptotal}}</b></td>
            <td class="totalback"><b>{{deliverypendingtotal}}</b></td>
            <td class="totalback"><b>{{totaldeliveredtotal}}</b></td>
            <td class="totalback"><b>{{handoverpendingtotal}}</b></td>
            <td class="totalback"><b>{{ndrtotal}}</b></td>
            <td class="totalback"><b>{{rtototal}}</b></td>
            
            <td class="totalback"><b>{{codcollectabletotal}}</b></td>
            <td class="totalback"><b>{{ofdtotal}}</b></td>
            <td class="totalback"><b></b></td>
          
   
    </template>
    <template slot="show_details" slot-scope="row" class="details">
     
              <b-button size="sm"   value="show" @click="row.toggleDetails();" class="mr-1">

                {{ row.detailsShowing ? 'Hide' : 'Show'}} 
                
              </b-button>
    </template>

   

    
          </b-table> -->

          <!-- new added code -->
            <!-- <b-table :items="items2" :fields="fields1" striped responsive="sm">
              <template v-slot:cell(show_details1)="row">
                <b-button size="sm" @click="row.toggleDetails1" class="mr-2">
                  {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                </b-button>

                
                <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
                  Details via check
                </b-form-checkbox>
              </template>

              <template v-slot:row-details="row">
                <b-card>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>Age:</b></b-col>
                    <b-col>{{ row.item.age }}</b-col>
                  </b-row>

                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>Is Active:</b></b-col>
                    <b-col>{{ row.item.isActive }}</b-col>
                  </b-row>

                  <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                </b-card>
              </template>
            </b-table> -->
<div>
   <!-- <button v-on:click="showdata()">Show</button> -->
  <!--  <b-button type="submit" size="md" variant="primary" @click="showdata"> Show</b-button></b-form-group> -->
   <button type="submit" size="md" class="btn btn-primary btn-md" variant="primary" @click="visible = !visible">{{ visible ? 'Hide Details' : 'Show Details'}} </button>
   <!-- <b-button type="submit" variant="primary" size="md" @click="downloadCSV" style="float: right">Download </b-button> -->
</div>
 <div id="overlay" >
             <div class="loader"></div>
           </div>
<table stickyheader="" role="table" aria-busy="false" aria-colcount="15" class="table b-table table-bordered b-table-stacked-md" id="__BVID__132" aria-describedby="__BVID__132__caption_" >
   <!----><!---->
   <thead role="rowgroup" class="">
      <!---->
      <tr role="row">
         <th tabindex="0" role="columnheader" scope="col" aria-colindex="1" class="">Name </th>
         <th tabindex="0" role="columnheader" scope="col" aria-colindex="2" class="">Forward <div style="float: right;" tabindex="0" role="columnheader" scope="col" aria-colindex="2"><div class="arrow-up" @click="displaydata('forwardpickup',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('forwardpickup',' desc')"></div></div>Pickup </th>

         <th tabindex="0" role="columnheader" scope="col" aria-colindex="3" >Reverse <div style="float: right;"><div class="arrow-up" @click="displaydata('reversepickup',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('reversepickup',' desc')"></div></div>Pickup </th>

         <th tabindex="0" role="columnheader" scope="col" aria-colindex="4" >OFD<div style="float: right;"><div class="arrow-up" @click="displaydata('deliverypending',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('deliverypending',' desc')"></div></div></th>

         <th tabindex="0" role="columnheader" scope="col" aria-colindex="5" >ROFD<div style="float: right;"><div class="arrow-up" @click="displaydata('deliverypendingreturn',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('deliverypendingreturn',' desc')"></div></div></th>

         <th tabindex="0" role="columnheader" scope="col" aria-colindex="6" style="width:170px;">INTRANSIT<div style="float: right;"><div class="arrow-up" @click="displaydata('deliverypendingintransit',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('deliverypendingintransit',' desc')"></div></div></th>

         <th tabindex="0" role="columnheader" scope="col" aria-colindex="7" >Delivered<div style="float: right;"><div class="arrow-up" @click="displaydata('totaldelivered',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('totaldelivered',' desc')"></div></div></th>

         <th tabindex="0" role="columnheader" scope="col" aria-colindex="8" >RVP<div style="float: right;"><div class="arrow-up" @click="displaydata('handoverpending',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('handoverpending',' desc')"></div></div>-HOP</th>

         <th tabindex="0" role="columnheader" scope="col" >RVP <div style="float: right;"><div class="arrow-up" @click="displaydata('reversepickcancel',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('reversepickcancel',' desc')"></div></div>NPR</th>

         <th tabindex="0" role="columnheader" scope="col" aria-colindex="9" >NDR <div style="float: right;"><div class="arrow-up" @click="displaydata('ndr',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('ndr',' desc')"></div></div></th>

         <th tabindex="0" role="columnheader" scope="col" aria-colindex="10" > RTO <div style="float: right;"><div class="arrow-up" @click="displaydata('totalrto',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('totalrto',' desc')"></div></div></th>

         <th tabindex="0" role="columnheader" scope="col" aria-colindex="11" >COD <div style="float: right;"><div class="arrow-up" @click="displaydata('codcollectable',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('codcollectable',' desc')"></div></div>Collected </th>

          <th tabindex="0" role="columnheader" scope="col" aria-colindex="13" >First <div style="float: right;"><div class="arrow-up" @click="displaydata('StartTime',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('StartTime',' desc')"></div></div>Delivery </th>

          <th tabindex="0" role="columnheader" scope="col" aria-colindex="14" >Last <div style="float: right;"><div class="arrow-up" @click="displaydata('EndTime',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('EndTime',' desc')"></div></div>Delivery </th>

         <th tabindex="0" role="columnheader" scope="col" >Total <div style="float: right;"><div class="arrow-up" @click="displaydata('totalofd',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('totalofd',' desc')"></div></div>OFD </th>
           
         <!-- <th tabindex="0" role="columnheader" scope="col" aria-colindex="11" class="">Show Details</th> -->
      </tr>
   </thead>
   <!---->
   <tbody role="rowgroup" class="">
      <tr role="row" class="b-table-top-row" >
         <td class="totalback"><b>Total</b></td>
         <td class="totalback"><b>{{forwardpickuptotal}}</b></td>
         <td class="totalback"><b>{{reversepickuptotal}}</b></td>
         <td class="totalback"><b>{{deliverypendingtotal}}</b></td>
          <td class="totalback"><b>{{deliverypendingreturntotal}}</b></td>
          <td class="totalback"><b>{{deliverypendingintransittotal}}</b></td>
         <td class="totalback"><b>{{totaldeliveredtotal}}</b></td>
         <td class="totalback"><b>{{handoverpendingtotal}}</b></td>
         <td class="totalback"><b>{{rvpnprtotal}}</b></td>
         <td class="totalback"><b>{{ndrtotal}}</b></td>
         <td class="totalback"><b>{{rtototal}}</b></td>
         <td class="totalback"><b>{{codcollectabletotal}}</b></td>
         <td class="totalback"><b>{{firstdelivery}}</b></td>
         <td class="totalback"><b>{{lastdelivery}}</b></td>
         <td class="totalback"><b>{{ofdtotal}}</b></td>
         
         <!-- <td class="totalback"><b></b></td> -->
      </tr>

     <!--  totalunique cx code row -->
        <tr role="row" v-if="visible">
          <td class="totalunique"><b>Total Unique CX</b></td>
          <td class="totalunique">{{forwardpickuptotalunique}}</td>
          <td class="totalunique">{{reversepickuptotalunique}}</td>
          <td class="totalunique">{{deliverypendingtotalunique}}</td>
          <td class="totalunique">{{deliverypendingreturntotalunique}}</td>
           <td class="totalunique">{{deliverypendingintransittotalunique}}</td>
          <td class="totalunique">{{totaldeliveredtotalunique}}</td>
          <td class="totalunique">{{handoverpendingtotalunique}}</td>
          <td class="totalunique">{{ofdtotalunique}}</td>
          <td class="totalunique">{{ndrtotalunique}}</td>
          <td class="totalunique">{{rtototalunique}}</td>
          <td class="totalunique">{{codcollectabletotalunique}}</td>
          <td class="totalunique">{{firstdeliveryunique}}</td>
          <td class="totalunique">{{lastdeliveryunique}}</td>
          <td class="totalunique">{{rvpnprtotalunique}}</td>
         
          
        </tr>
     <!--  totalunique cx code row end-->
      <!-- <div id="foo"></div>
      <div class="wrapper">
    <div class="header" v-on:click="collapsed = !collapsed"></div>
    <div class="collapsible" v-show="!collapsed"></div>
  </div> -->
  
      <tr role="row"  v-for="items in items">
         <td role="cell" aria-colindex="1" data-label="Name" class="">
            <div>{{items.daname}}</div>
            
         </td>
         <td role="cell" aria-colindex="2" data-label="Forward Pickup" class="">
            <div>{{items.forwardpickup}}</div>
            <div v-if="visible">{{items.uniqueforwardpickup}}</div>
         </td>
         <td role="cell" aria-colindex="3" data-label="Reverse Pickup" class="">
            <div>{{items.reversepickup}}</div>
             <div v-if="visible">{{items.uniquereversepickup}}</div>
         </td>
         <td role="cell" aria-colindex="4" data-label="Delivery Pending" class="">
            <div>{{items.deliverypending}}</div>
            <div v-if="visible">{{items.uniquedeliverypending}}</div>
         </td>
          <td role="cell" aria-colindex="5" data-label="Delivery Pending" class="">
            <div>{{items.deliverypendingreturn}}</div>
            <div v-if="visible">{{items.uniquedeliverypendingreturn}}</div>
         </td>
         <td role="cell" aria-colindex="6" data-label="Delivery Pending" class="">
            <div>{{items.deliverypendingintransit}}</div>
            <div v-if="visible">{{items.uniquedeliverypendingintransit}}</div>
         </td>
         <td role="cell" aria-colindex="7" data-label="Delivered" class="">
            <div>{{items.totaldelivered}}</div>
            <div v-if="visible">{{items.uniquetotaldelivered}}</div>
         </td>
         <td role="cell" aria-colindex="8" data-label="RVP-HOP" class="">
            <div>{{items.handoverpending}}</div>
            <div v-if="visible">{{items.uniquehandoverpending}}</div>
         </td>
          <td role="cell" aria-colindex="12" data-label="Total OFd" class="">
            <div>{{items.reversepickcancel}}</div>
            <div v-if="visible">{{items.uniquereversepickcancel}}</div>
            
         </td>
         <td role="cell" aria-colindex="9" data-label="NDR" class="">
            <div>{{items.ndr}}</div>
            <div v-if="visible">{{items.uniquendr}}</div>
         </td>
         <td role="cell" aria-colindex="10" data-label=" RTO" class="">
            <div>{{items.totalrto}}</div>
            <div v-if="visible">{{items.uniquetotalrto}}</div>
         </td>
         <td role="cell" aria-colindex="11" data-label="COD collected" class="">
            <div>{{items.codcollectable}}</div>
            <div v-if="visible"></div>
           
         </td>
         <td role="cell" aria-colindex="13" data-label="First Delivery" class="">
            <div>{{items.StartTime}}</div>
            <div v-if="visible"></div>
           
         </td>
          <td role="cell" aria-colindex="14" data-label="Last Delivery" class="">
            <div>{{items.EndTime}}</div>
            <div v-if="visible"></div>
           
         </td>
         <td role="cell" aria-colindex="15" data-label="Total OFd" class="">
            <div>{{items.totalofd}}</div>
            <div v-if="visible"></div>
            
         </td>
          

         
      </tr>

    <!--  <tr role="row"  v-for="items in items" v-if="items.flag='1'">
         <td role="cell" aria-colindex="1" data-label="Name" class="">
            <div>{{items.daname}}</div>
         </td>
         <td role="cell" aria-colindex="2" data-label="Forward Pickup" class="">
            <div>{{items.uniqueforwardpickup}}</div>
         </td>
         <td role="cell" aria-colindex="3" data-label="Reverse Pickup" class="">
            <div>{{items.reversepickup}}</div>
         </td>
         <td role="cell" aria-colindex="4" data-label="Delivery Pending" class="">
            <div>{{items.deliverypending}}</div>
         </td>
         <td role="cell" aria-colindex="5" data-label="Delivered" class="">
            <div>{{items.totaldelivered}}</div>
         </td>
         <td role="cell" aria-colindex="6" data-label="RVP-HOP" class="">
            <div>{{items.handoverpending}}</div>
         </td>
         <td role="cell" aria-colindex="7" data-label="NDR" class="">
            <div>{{items.ndr}}</div>
         </td>
         <td role="cell" aria-colindex="8" data-label=" RTO" class="">
            <div>{{items.totalrto}}</div>
         </td>
         <td role="cell" aria-colindex="9" data-label="COD collected" class="">
            <div>{{items.codcollectable}}</div>
         </td>
         <td role="cell" aria-colindex="10" data-label="Total OFd" class="">
            <div>{{items.totalofd}}</div>
         </td>

         
      </tr> -->

      <!-- <tr role="row" >
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        <td>1</td>
        

      </tr>
      <tr role="row" v-if="visible">
        <td>2</td>
        <td>2</td>
        <td>2</td>
        <td>2</td>
        <td>2</td>
        <td>2</td>
        <td>2</td>
        <td>2</td>
        <td>2</td>
        <td>2</td>
        

      </tr>
      <tr role="row" >
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        

      </tr>

       <tr role="row" v-if="visible">
        <td>4</td>
        <td>4</td>
        <td>4</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        <td>3</td>
        

      </tr>
 -->
    <!--   <tr role="row" class="">
         <td role="cell" aria-colindex="1" data-label="Name" class="">
            <div>MukeshPatil-477</div>
         </td>
         <td role="cell" aria-colindex="2" data-label="Forward Pickup" class="">
            <div>0</div>
         </td>
         <td role="cell" aria-colindex="3" data-label="Reverse Pickup" class="">
            <div>0</div>
         </td>
         <td role="cell" aria-colindex="4" data-label="Delivery Pending" class="">
            <div>0</div>
         </td>
         <td role="cell" aria-colindex="5" data-label="Delivered" class="">
            <div>0</div>
         </td>
         <td role="cell" aria-colindex="6" data-label="RVP-HOP" class="">
            <div>0</div>
         </td>
         <td role="cell" aria-colindex="7" data-label="NDR" class="">
            <div>0</div>
         </td>
         <td role="cell" aria-colindex="8" data-label=" RTO" class="">
            <div>0</div>
         </td>
         <td role="cell" aria-colindex="9" data-label="COD collected" class="">
            <div>0</div>
         </td>
         <td role="cell" aria-colindex="10" data-label="Total OFd" class="">
            <div>0</div>
         </td>
         <td role="cell" aria-colindex="11" data-label="Show Details" class="">
            <div><button value="show" type="button" class="btn mr-1 btn-secondary btn-sm">
               Show 
               </button>
            </div>
         </td>
      </tr> -->
      <!----><!---->
   </tbody>
</table>

  <!-- <div id="foo">

</div>


  <div class="wrapper" id="collapsible">
    <div class="header" v-on:click="collapsed = !collapsed"></div>
    <div class="collapsible" v-show="!collapsed"></div>
  </div>

  <div id="app">
    <button v-on:click="collapseAll">Collapse All</button>
    <button v-on:click="expandAll">Expand All</button>
    <collapsible ref="collapsible" v-for="items in items" v-bind:collapseAll="collapseAll" v-bind:key="items"></collapsible>
  </div> -->

          <!-- new added code end -->
          <!-- <b-col md="6" class="my-1" v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col> -->
        </b-card>
        
      </b-col>
    </b-row>       
    </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
export default {

  
  data: function() {
    return {
      name: 'deliveryStatusReport',
      data: [],
      items:[],
      isHidden: true,
       items1:[],
      customer: {},
      visible: false,
      bordered:true,
      selectedDate: new Date(),
      fields: [
          { key: 'daname', label: 'Name', sortable: true, sortDirection: 'desc' },
          { key: 'forwardpickup', label: 'Forward Pickup', sortable: true},
          { key: 'reversepickup', label: 'Reverse Pickup', sortable: true},
          { key: 'deliverypending', label: 'Delivery Pending', sortable: true},
          { key: 'deliverypendingreturn', label: 'Delivery Pending Return', sortable: true},
          { key: 'deliverypendingintransit', label: 'Delivery Pending Intransit', sortable: true},         
          { key: 'totaldelivered', label: 'Delivered', sortable: true },    
          { key: 'handoverpending', label: 'RVP-HOP', sortable: true },
          { key: 'ndr', label: 'NDR', sortable: true },
          { key: 'totalrto', label: ' RTO' , sortable: true},
          // { key: 'failedpickup', label: 'Failed pickup', sortable: true },
          { key: 'codcollectable', label: 'COD collected', sortable: true  },
           { key: 'Today_First_Delivered_Shipment_Time', label: 'First Delivery', sortable: true  },
            { key: 'Today_Last_Delivered_Shipment_Time', label: 'Last Delivery', sortable: true  },
          { key: 'totalofd', label: 'Total OFd' },
          { key: 'show_details' },
       ], 

       
      totalRows: 0,
      currentPage: 1,
         value2:[],
         agentfields: { text: 'name', value: 'id' },
         options: [],
          showSelectAll : true,
           allowCustomValue : true,
     
      pageOptions: [5, 10, 15],
      sortBy: null,
      stickyHeader: true,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      forwardpickuptotal:0,
       reversepickuptotal:0,
        deliverypendingtotal:0,
        deliverypendingreturntotal:0,
        deliverypendingintransittotal:0,
        totaldeliveredtotal:0,
        handoverpendingtotal:0,
        ndrtotal:0,
        rtototal:0,
       // failedpickuptotal:0,
        codcollectabletotal:0,
         ofdtotal:0,
         rvpnprtotal:0,
         firstdelivery:0,
         lastdelivery:0,
         //totoaluniquecx variables
        forwardpickuptotalunique:0,
        reversepickuptotalunique:0,
        deliverypendingtotalunique:0,
        deliverypendingreturntotalunique:0,
        deliverypendingintransittotalunique:0,
        totaldeliveredtotalunique:0,
        handoverpendingtotalunique:0,
        ndrtotalunique:0,
        rtototalunique:0,
        codcollectabletotalunique:0,
        ofdtotalunique:0,
        rvpnprtotalunique:0,
        flag:0,
        firstdeliveryunique:0,
        lastdeliveryunique:0,

        //Added Fields by Sachin
        forwardpickup:'',
        reversepickup:'',
        deliverypending:'',
        deliverypendingreturn:'',
        deliverypendingintransit:'',
        totaldelivered:'',
        handoverpending:'',
        reversepickcancel:'',
        ndr:'',
        totalrto:'',
        codcollectable:'',
        StartTime:'',
        EndTime:'',
        totalofd:'',
        FirstSet: {},
        //Added Fileds by Sachin Ends
         //totoaluniquecx variables end


      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },

  computed: {
    sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
  },


  created: function () {
     this.displaydeliveryagent();
    
  },
  // components: {
  //   collapsible: collapsible
  // },
//   var collapsible = {
//   template: "#collapsible",
  
// }
  methods: {
    
     info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      
//   testDisplay:function(test) {
//     if (document.getElementById("portests").value == "Hide " + test) {
//         document.getElementById("portests").value = "Show " + test;
//         var table= document.getElementById("testing");
//         for (var i = 0, row; row = table.rows[i]; i++) {
//         if(row.className == "test"){row.style.visibility="hidden";}
//         }
//     }
//     else{
//         document.getElementById("portests").value = "Hide " + test;
//         var table= document.getElementById("testing");
//         for (var i = 0, row; row = table.rows[i]; i++) {
//         if(row.className == "test"){row.style.visibility='visible';}
//         }
//     }
// },
    showdata: function (){
      if(isHidden==true){
        isHidden: false;
      }
    }, 
    // showHideDiv: function(ele) {
    //     var srcElement = document.getElementById(ele);
    //     if (srcElement != null) {
    //       if (srcElement.style.display == "block") {
    //         srcElement.style.display = 'none';
    //       }
    //       else {
    //         srcElement.style.display = 'block';
    //       }
    //       return false;
    //     }
    //   },
    //   collapseAll(){
    //   this.$refs.collapsible.map(c => c.collapsed = true)
    // },
    // expandAll(){
    //   this.$refs.collapsible.map(c => c.collapsed = false)
    // },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    // validateForm(scope) {


    // },
   
    refresh: function () {
      document.getElementById('refreshId').className = 'fa-spin fa fa-refresh'
      this.displaydata()
    },
    GetSortOrder : function(prop) {
        return function(a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        }

    },

    //code for download csv
    downloadCSV: function() {
   
       var deliveryagentidarr=[];
      deliveryagentidarr=this.value2;
      
      var fromdate = this.formatDate(this.selectedDate);

      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      
     
          var csvObj = {
           deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          fromdate: `${fromdate}`,
           deliveryagentmasterid:deliveryagentidarr,
            hub_id:`${userInfo.pickuplocationmasterid}`,
      
          // flag:this.flag,
          };
         
       
 

      //console.log(csvObj);
      
        var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
      // if(formatdateto< fromdate){
      //   alert('To date need to be grater than From date');
          
      // }
      //var r = Math.random().toString(36).substring(3);
      this.$http
        .get(`${CONSTANTS.MISREPORT_API_URL}/statusreportdailymailcsv`+queryString)
        .then(result => {
         // console.log(result.url);
        window.location.href =result.url;
        });
        
    },
    // download csv code end

     displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
         hub_id:`${userInfo.pickuplocationmasterid}`,
      
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
           this.displaydata();
          this.agentmaster = result.body;

           for(var i = 0; i < this.agentmaster.length; i++) {
            var deliveryagent2 = {
        name: this.agentmaster[i].deliveryagentmasterid+" - "+this.agentmaster[i].deliveryagentfirstname+" - "+this.agentmaster[i].deliveryagentlastname,
        id: this.agentmaster[i].deliveryagentmasterid
      }
 this.options.push(deliveryagent2);

        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }
       // console.log('--------gfg----------');
       // console.log(this.options);
       //        console.log('------------------');

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    
    displaydata: function (col_name, order) {
      document.getElementById("overlay").style.display = "block";
     console.log("Col Name",col_name);
     console.log("order Name",order);
       var deliveryagentidarr=[];
          deliveryagentidarr=this.value2;
      
      var fromdate = this.formatDate(this.selectedDate);

      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      
           
      const customerGetobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          fromdate: `${fromdate}`,
           deliveryagentmasterid:deliveryagentidarr,
            hub_id:`${userInfo.pickuplocationmasterid}`,
            // FirstSetData: this.FirstSet
            // 'FirstSet.+col_name': col_name+''+order
          
        // pickuplocationmasterid:`${userInfo.pickuplocationmasterid}`,
      
      
      }
      if(col_name!=undefined){
        customerGetobj['order_by']='FirstSet.'+col_name+''+order;
      }
      else{
        customerGetobj['order_by']='';
      }
      
      console.log("ddddddddddddddddddDDDDDDDDDDDD",customerGetobj)
      // return false;
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getalldapendingstatusreport_mr`, customerGetobj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            document.getElementById("overlay").style.display = "none";
          this.data = result.body.returnvalue;
          // console.log('hii',this.data);
          this.items  = result.body.returnvalue;
           // console.log("JJJJJJJJJJJJJJJJJJJJ",this.items)
          // console.log("PPPPPPPPPPPPPPPPPPPPPPP",this.items);
          // console.log('hello',this.items);
          this.totalRows = result.body.returnvalue.length;

          this.forwardpickuptotal =0;
          this.reversepickuptotal =0;
          this.deliverypendingtotal =0;
          this.deliverypendingreturntotal=0;
          this.deliverypendingintransittotal=0;
          this.totaldeliveredtotal =0;
          this.handoverpendingtotal =0;
          this.ndrtotal=0;
          this.rtototal =0;
          this.codcollectabletotal =0;
          // this.firstdelivery=0;
          // this.lastdelivery=0;
          
          this.ofdtotal =0;
          this.rvpnprtotal=0;
          //this.failedpickuptotal =0;

          //totalunique code
          this.forwardpickuptotalunique=0;
          this.reversepickuptotalunique=0;
          this.deliverypendingtotalunique=0;
          this.deliverypendingreturntotalunique=0;
          this.deliverypendingintransittotalunique=0;
          this.totaldeliveredtotalunique=0;
          this.handoverpendingtotalunique=0;
          this.ndrtotalunique=0;
          this.rtototalunique=0;
          this.codcollectabletotalunique=0;
          this.firstdeliveryunique=0;
          this.lastdeliveryunique=0;
          this.ofdtotalunique=0;
          this.rvpnprtotalunique=0;
          //totalunique code end


          for( var i=0;i<= this.totalRows;i++)
          {
            // console.log("falg",this.items[i].flag);
            if(this.items[i].flag==0){
              // console.log("items",this.items[i]);
              this.forwardpickuptotal=parseInt(this.forwardpickuptotal+ this.items[i].forwardpickup);
             // console.log("@@@@@@@@@@@this.forwardpickuptotal",this.forwardpickuptotal);

            this.reversepickuptotal=parseInt(this.reversepickuptotal+ this.items[i].reversepickup);

           this.deliverypendingtotal=parseInt(this.deliverypendingtotal+ this.items[i].deliverypending);
           this.deliverypendingreturntotal=parseInt(this.deliverypendingreturntotal+ this.items[i].deliverypendingreturn);
           // console.log("return",this.deliverypendingtotal);
           this.deliverypendingintransittotal=parseInt(this.deliverypendingintransittotal+ this.items[i].deliverypendingintransit);
           // console.log("return", this.deliverypendingintransittotal);
            this.totaldeliveredtotal=parseInt(this.totaldeliveredtotal+ this.items[i].totaldelivered);

            this.handoverpendingtotal=parseInt(this.handoverpendingtotal+ this.items[i].handoverpending);
            this.ndrtotal=parseInt(this.ndrtotal+ this.items[i].ndr);

            this.rtototal=parseInt(this.rtototal+ this.items[i].totalrto);

            //this.failedpickuptotal=parseInt(this.failedpickuptotal+ this.items[i].failedpickup);

            this.codcollectabletotal= (parseFloat(this.codcollectabletotal)+ parseFloat(this.items[i].codcollectable)).toFixed(2);

             this.firstdelivery=this.data.StartTime

              this.lastdelivery=this.data.EndTime;

            this.ofdtotal=parseInt(this.ofdtotal+ this.items[i].totalofd);
             this.rvpnprtotal=parseInt(this.rvpnprtotal+ this.items[i].reversepickcancel);

             
            }
            else if(this.items[i].flag==1){
                this.forwardpickuptotalunique=parseInt(this.forwardpickuptotalunique+ this.items[i].uniqueforwardpickup);
            // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$",this.forwardpickuptotalunique);
            this.reversepickuptotalunique=parseInt(this.reversepickuptotalunique+ this.items[i].uniquereversepickup);

           this.deliverypendingtotalunique=parseInt(this.deliverypendingtotalunique+ this.items[i].uniquedeliverypending);

           this.deliverypendingreturntotalunique=parseInt(this.deliverypendingreturntotalunique+ this.items[i].uniquedeliverypendingreturn);

            this.deliverypendingintransittotalunique=parseInt(this.deliverypendingintransittotalunique+ this.items[i].uniquedeliverypendingintransit);


            this.totaldeliveredtotalunique=parseInt(this.totaldeliveredtotalunique+ this.items[i].uniquetotaldelivered);

            this.handoverpendingtotalunique=parseInt(this.handoverpendingtotalunique+ this.items[i].uniquehandoverpending);
            this.ndrtotalunique=parseInt(this.ndrtotalunique+ this.items[i].uniquendr);

            this.rtototalunique=parseInt(this.rtototalunique+ this.items[i].uniquetotalrto);
            this.rvpnprtotalunique=parseInt(this.rvpnprtotalunique+ this.items[i].uniquereversepickcancel);

            //this.failedpickuptotal=parseInt(this.failedpickuptotal+ this.items[i].failedpickup);

            // this.codcollectabletotalunique= (parseFloat(this.codcollectabletotalunique)+ parseFloat(this.items[i].uniquecodcollectable)).toFixed(2);

            // this.ofdtotalunique=parseInt(this.ofdtotalunique+ this.items[i].uniqueofd);

            }


          }
          // this.totalofdtotal= (parseFloat(this.deliverypendingtotal)+ parseFloat(this.totaldeliveredtotal)+ parseFloat(this.ndrtotal));

          document.getElementById('refreshId').className = 'fa fa-refresh';


          } 
          else 
          {
            document.getElementById("overlay").style.display = "none";
            //alert('No records found')
            this.items=[];
          this.forwardpickuptotal =0;
          this.reversepickuptotal =0;
          this.deliverypendingtotal =0;
          this.deliverypendingreturntotal=0;
          this.deliverypendingintransittotal=0;
          this.totaldeliveredtotal =0;
          this.handoverpendingtotal =0;
          this.ndrtotal=0;
          this.rtototal =0;
          this.codcollectabletotal =0;
          this.firstdelivery=0;
          this.lastdelivery=0;
           this.ofdtotal =0;
            this.totalRows=0;
            this.rvpnprtotalunique=0;
            this.rvpnprtotal=0;

          }

          // //code for unique
           //  this.forwardpickuptotalunique=parseInt(this.forwardpickuptotalunique+ this.items[i].forwardpickupunique);
           //  console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$",this.forwardpickuptotalunique);
           //  this.reversepickuptotalunique=parseInt(this.reversepickuptotalunique+ this.items[i].reversepickupunique);

           // this.deliverypendingtotalunique=parseInt(this.deliverypendingtotalunique+ this.items[i].deliverypendingunique);

           //  this.totaldeliveredtotalunique=parseInt(this.totaldeliveredtotalunique+ this.items[i].totaldeliveredunique);

           //  this.handoverpendingtotalunique=parseInt(this.handoverpendingtotalunique+ this.items[i].handoverpendingunique);
           //  this.ndrtotalunique=parseInt(this.ndrtotalunique+ this.items[i].ndrunique);

           //  this.rtototalunique=parseInt(this.rtototalunique+ this.items[i].totalrtounique);

           //  //this.failedpickuptotal=parseInt(this.failedpickuptotal+ this.items[i].failedpickup);

           //  this.codcollectabletotalunique= (parseFloat(this.codcollectabletotalunique)+ parseFloat(this.items[i].codcollectableunique)).toFixed(2);

           //  this.ofdtotalunique=parseInt(this.ofdtotalunique+ this.items[i].ofdunique);
          //   //code for unique end 

        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
}
</script>

<style type="text/css">
 .totalback
 {
  background: #CACDCD !important;
   border-right: 1px solid grey !important;
   

  }
  .totalunique
 {
  background: #DDDFDF!important;
   border-right: 1px solid grey !important;
   

  }
  table {
  width: 100%;
  margin: 20px auto;
  table-layout: auto;
}

.fixed {
  table-layout: fixed;
}

table,
td,
th {
  border-collapse: collapse;
}
.trshow{
  display: none;
}

/*  .details{
        width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
  }
   */
  /*.mr-1{
   width: 100% !important;
    margin-bottom: 1rem;
    background-color: transparent;
    max-width:100%;
}*/
/*.td{
  width: 50px !important;
}*/
.arrow-up {
  width: 0; 
  height: 0; 
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 7px solid #1E90FF;
}

.arrow-down {
  width: 0; 
  height: 0; 
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 7px solid #1E90FF;
}
</style>